import { render } from "./DenominationView.vue?vue&type=template&id=497778c6"
import script from "./DenominationView.vue?vue&type=script&lang=js"
export * from "./DenominationView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__